var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_27617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2375 9.97582C20.2375 15.4853 15.7713 19.9516 10.2616 19.9516C4.75201 19.9516 0.285645 15.4853 0.285645 9.97582C0.285645 4.46636 4.75201 0 10.2616 0C15.7713 0 20.2375 4.46636 20.2375 9.97582Z",
    fill: "#1E2329"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_473_27617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95597 9.04264L10.2867 6.71211L12.6182 9.04358L13.9744 7.68764L10.2867 4L6.60003 7.68647L7.95597 9.0424M4.28638 10.0004L5.64255 8.64394L6.99849 10.0004L5.64232 11.3558L4.28638 10.0004ZM7.95597 10.9578L10.2867 13.2881L12.6182 10.9567L13.9751 12.3119L10.2867 16.0007L6.60003 12.3138L6.59815 12.3117L7.95597 10.9576M13.5745 10.0004L14.9304 8.64441L16.2871 10.0004L14.9311 11.3563L13.5745 10.0004Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6616 10.0001L10.2867 8.62305L9.26945 9.63983L9.15226 9.75702L8.91154 9.99774L8.90967 9.99961L8.91154 10.0015L10.2867 11.3764L11.6626 10.0005H11.6614",
    fill: "#F3BA2F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_27617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.285645)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_473_27617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4.28638 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.dca8fb3691cbc18fc5798e7f6185b4bc.svg";
export { ForwardRef as ReactComponent };